const datatable = {
  en: {
    datatable: {
      search: {
        actions: {
          find: 'Find',
          reset: 'Reset Search',
          search: 'Search'
        },
        empty_results: 'Nothing was found.',
        types: {
          media_tag: 'Media Tag',
          article_feature: 'Article Feature',
          media_feature: 'Media Feature',
          article_detail: 'Article Detail',
          grouping: 'Grouping',
          source: 'Source',
          coder_id: 'Coder',
          user_country_code: "Social Profile Location",
          country_code: 'Country',
          keyword: 'Text',
          // free_text: 'Text',
          media_subtypes: 'Media Type',
          media_type: 'Media Type',
          outlet_name: 'Outlet',
          search: 'Search',
          status_id: 'Status',
          text_in_headline: 'Headline',
          text_in_outlet: 'Text in outlet',
          article: 'Article Id',
          article_id: 'Article Id',
          tag_id: 'Tag',
          insight_tag_id: 'Insight Tag',
          languages:'Language',
          source_url: 'Source URL',
          insight_url: 'Insight URL',
          coding_uid: 'Coding UID',
          relevancy: 'Relevancy',
          author_id: 'Author',
          social: 'Social'
        }
      },
      header_filters: {
        actions: {
          clear: 'Clear',
          apply: 'Apply'
        },
        empty_results: 'Nothing was found.'
      },
      empty_results: 'There is no available data.',
      empty_articles: 'There are no articles to show. Consider changing your search criteria.',
      empty_projects: 'There are no projects to show. Consider changing your search criteria.',
      empty_users: 'User not found. Consider changing your criteria ',
      no_content: 'N/A',
      bulk_actions: {
        resource_types: {
          resource: 'Resource | Resources',
          article: 'Article | Articles',
          source: 'Source | Sources',
          country: 'Country | Countries',
          author:  'Author | Authors',
          user: 'User | Users',
          story: 'Story | Stories',
          skipped_article: 'Skipped article | Skipped articles'
        }
      }
    }
  }
}

module.exports.datatable = datatable;